import React from 'react';
import PropTypes from 'prop-types';
import themable from 'zignal-landscape/lib/themeable';
import MediaOutletSearchResult from './components/MediaOutletSearchResult/MediaOutletSearchResult';
import DomainSearchResult from './components/DomainSearchResult/DomainSearchResult';

const SourceCheckerResult = ({
  styles,
  searchType,
  domain,
  authorGroupNames,
  isCovered,
  isValid,
  lastCoveredAt,
  mediaOutlet,
  showMatchingAuthorGroups,
  sourceProviders,
  storyCount,
  hasGroups,
}) => {

  switch (searchType) {
    case 'mediaOutlet':
      return (<MediaOutletSearchResult
        domain={domain}
        authorGroupNames={authorGroupNames}
        isCovered={isCovered}
        isValid={isValid}
        lastCoveredAt={lastCoveredAt}
        mediaOutlet={mediaOutlet}
        showMatchingAuthorGroups={showMatchingAuthorGroups}
        sourceProviders={sourceProviders}
        storyCount={storyCount}
        hasGroups={hasGroups}
        styles={styles}
      />);
    case 'domain':
      return (<DomainSearchResult
        domain={domain}
        authorGroupNames={authorGroupNames}
        isCovered={isCovered}
        isValid={isValid}
        lastCoveredAt={lastCoveredAt}
        mediaOutlet={mediaOutlet}
        showMatchingAuthorGroups={showMatchingAuthorGroups}
        sourceProviders={sourceProviders}
        storyCount={storyCount}
        hasGroups={hasGroups}
        styles={styles}
      />);
    default:
      return null;
  }
};

SourceCheckerResult.propTypes = {
  styles: PropTypes.object,
  domain: PropTypes.string,
  authorGroupNames: PropTypes.arrayOf(PropTypes.string),
  isCovered: PropTypes.bool,
  isValid: PropTypes.bool,
  lastCoveredAt: PropTypes.string,
  mediaOutlet: PropTypes.string,
  searchType: PropTypes.oneOf(['domain', 'mediaOutlet']),
  showMatchingAuthorGroups: PropTypes.bool,
  sourceProviders: PropTypes.arrayOf(PropTypes.string),
  storyCount: PropTypes.number,
  hasGroups: PropTypes.bool,
};

export default themable(SourceCheckerResult);
